import axios from 'axios';

const BASE  = process.env.REACT_APP_API_BASE_URL;
const TOKEN = process.env.REACT_APP_API_TOKEN;

console.log('[API] BASE:', BASE, '| TOKEN:', TOKEN);

export const getCategories = () =>
  axios.get(`${BASE}/frontapi/getcategories/${TOKEN}`);

export const submitNomination = (data) =>
  axios.post(`${BASE}/frontapi/submitnomination/${TOKEN}`, data);
